import { render, staticRenderFns } from "./TermsArrayEditor.vue?vue&type=template&id=ec3ba6fe&scoped=true&"
import script from "./TermsArrayEditor.vue?vue&type=script&lang=js&"
export * from "./TermsArrayEditor.vue?vue&type=script&lang=js&"
import style0 from "./TermsArrayEditor.vue?vue&type=style&index=0&id=ec3ba6fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3ba6fe",
  null
  
)

export default component.exports